function defaultTo(value, defaultValue) {
  return (value == null || value !== value) ? defaultValue : value
}

var theme = theme || {};

theme.Currency = (function() {
  var moneyFormat = '${{amount}}';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

class CartAddons extends HTMLElement {
  constructor() {
    super();

    this.productCount = 6;

    this.fetchRecommendations = this.fetchRecommendations.bind(this);
  }

  buildProductRecommendation (item, count) {
    var vendor = 'Beautifect';

    var itemHtml = document.createElement('div');
    itemHtml.classList.add('item');
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.id = 'quick-add-template--' + item.id;
    form.acceptCharset = 'UTF-8';
    form.enctype = 'multipart/form-data';
    form.noValidate = 'novalidate';
    form.dataset.type = 'add-to-cart-form';
    form.classList.add('form');

    form.innerHTML = `
        <input
          type="hidden"
          name="id"
          value="${item.variants[0].id}"
          class="product-variant-id"
        >
        <button
          id="quick-add-template--${item.id}-submit"
          type="submit"
          name="add"
          class="quick-add__submit button button--full-width button--secondary"
          aria-haspopup="dialog"
          aria-labelledby="quick-add-template--${item.id}-submit"
          aria-live="polite"
        >
          <span>
            Add
          </span>
          <span class="icon-wrap">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
              focusable="false"
              class="icon icon-plus"
              fill="none"
              viewBox="0 0 10 10"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor">
            </svg>
          </span>
          <div class="loading__spinner hidden">
            <svg
              aria-hidden="true"
              focusable="false"
              class="spinner"
              viewBox="0 0 66 66"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        </button>
    `;

    let line_item_price = '';
    if (item.tags.includes('automatic_discount_20') || item.tags.includes('automatic_discount_25') || item.tags.includes('automatic_discount_30')) {
      let dicounted_price = item.price;
      if (item.tags.includes('automatic_discount_20')) {
        dicounted_price = item.price * 0.8;
      }else if (item.tags.includes('automatic_discount_25')) {
        dicounted_price = item.price * 0.75;
      }else if (item.tags.includes('automatic_discount_30')) {
        dicounted_price = item.price * 0.7;
      }
      line_item_price = `
        <span class="line-throug-red">
           ${theme.Currency.formatMoney(item.price, theme.settings.moneyFormat)}
        </span>
        ${theme.Currency.formatMoney(dicounted_price, theme.settings.moneyFormat)}
      `;
    }else{
      line_item_price = `
        <span>
           ${theme.Currency.formatMoney(item.price, theme.settings.moneyFormat)}
        </span>
      `;
    }

    itemHtml.innerHTML = `
        <div class="img">
            <a href="/products/${item.handle}">
                <img alt="${item.title}" src="${item.images[0]}" />
            </a>
        </div>
        <div class="title">
            <p class="vendor">${vendor}</p>
            <div>${item.title.replace(vendor,'')}</div>
        </div>
        <div class="add_cart">
            ${line_item_price}
        </div>
        <product-form data-section-id="addons">
            ${form.outerHTML}
        </product-form>
    `;

    var listHtml = `
      <li
          id="Slide-cart-addons-${count}"
          class="grid__item slider__slide scroll-trigger"
          style="width: 50%;"
      >
          ${itemHtml.outerHTML}
      </li>
    `;

    return listHtml;
  }

  productInBasket(c, p) {
    var t = false;
    c.forEach((item) => {
      if (item.product_id === p) {
        t = true;
      }
    });
    return t;
  }

  async fetchRecommendations () {
    var cart = await fetch('/cart.json')
      .then(function (res) {
        return res.json();
      });

    var $counter = 0;
    var itemString = '';
    var recommendations = [];

    for (let item of cart.items) {
      var complementaryUrl = '/recommendations/products.json?product_id=' + item.product_id + '&intent=complementary';

      await fetch(complementaryUrl)
        .then(function (res) {
          return res.json();
        })
        .then((data) => {
          if (data.products.length > 0) {
            data.products.forEach((item) => {
              if ($counter < this.productCount) {
                var inBasket = this.productInBasket(cart.items, item.id);
                var inRecommendations = recommendations.indexOf(item.id);

                if (!inBasket && inRecommendations === -1 && item.available) {
                  recommendations.push(item.id);
                  itemString += this.buildProductRecommendation(item, $counter);
                  $counter += 1;
                }
              }
            });
          }
        });
    }

    if ($counter < this.productCount) {
      const prodId = cart?.items[0]?.product_id;

      if(prodId) {
        var recommendationsUrl = '/recommendations/products.json?product_id=' + prodId;

        await fetch(recommendationsUrl)
          .then(function (res) {
            return res.json();
          })
          .then((data) => {
            if (data?.products?.length > 0) {
              data.products.forEach((item) => {
                if ($counter < this.productCount) {
                  var inBasket = this.productInBasket(cart.items, item.id);
                  var inRecommendations = recommendations.indexOf(item.id);
  
                  if (!inBasket && inRecommendations === -1 && item.available) {
                    itemString += this.buildProductRecommendation(item, $counter)
                    $counter += 1;
                  }
                }
              });
            }
          }); 
      }
    }

    this.querySelector('.wrapper ul').innerHTML = itemString;

    this.querySelector('slider-component').resetPages();
  }
}

customElements.define('cart-addons', CartAddons);

document.querySelector('cart-addons').fetchRecommendations();